module.exports = __webpack_public_path__ + "static/popular-products-bb83b001bf84ef3936424e44c86b2de8.png";